import { cva, type VariantProps } from 'class-variance-authority';

export { default as PAvatar } from './PAvatar.vue';
export { default as PAvatarFallback } from './PAvatarFallback.vue';
export { default as PAvatarImage } from './PAvatarImage.vue';

export const pAvatarVariants = cva('', {
    variants: {
        variant: {
            default: 'rounded-full',
            square: 'rounded-sm aspect-ratio[1/1]',
        },
        size: {
            xs: 'size-5 paragraph-xs',
            sm: 'size-6 paragraph-xs',
            default: 'size-8 paragraph-xs',
            lg: 'size-12 paragraph-sm',
            xl: 'size-16 paragraph-sm',
        },
    },
    defaultVariants: {
        variant: 'default',
        size: 'default',
    },
});

export type PAvatarVariants = VariantProps<typeof pAvatarVariants>;
